/**
 * Convert dates passed in as strings from the Json API to localised values.
 *
 * The API will always pass ISO dates, so it _should_ be safe to use Date.parse()...
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
 *
 * Date/Time widgets
 * -----------------
 * Year (YYYY)
 * DateTimeStamp (HH:MMpm DD MMM YYYY)
 * DateStamp (DD MMM YYYY)
 * DateOnly (DD MMM)
 * TimeOnly (HH:MMpm)
 */

export const asYear = (str) => {
    if (! str) { return '-'; }
    const parsed = Date.parse(str);
    if (isNaN(parsed)) {
        console.log("Date not recognised as valid:", str);
        return '?';
    }
    return parsed.getFullYear();
};
/*
export const asDateTimeStamp = (str) => {
    if (! str) { return '-'; }
    const parsed = Date.parse(str);
    if (isNaN(parsed)) {
        console.log("Date not recognised as valid:", str);
        return '?';
    }

    const options = {
        hour: 'numeric',
        minute: 'numeric',
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    };
    return new Intl.DateTimeFormat(navigator.language, options).format(parsed);
};
*/
export const asDateStamp = (str, timeZone) => {
    if (! str) { return '-'; }
    const parsed = Date.parse(str);
    if (isNaN(parsed)) {
        console.log("Date not recognised as valid:", str);
        return '?';
    }

    const options = {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    };

    if (timeZone) {
        options['timeZone'] = timeZone;
    }
    return new Intl.DateTimeFormat(navigator.language, options).format(parsed);
};


export const asDateOnly = (str, timeZone) => {
    if (! str) { return '-'; }
    const parsed = Date.parse(str);
    if (isNaN(parsed)) {
        console.log("Date not recognised as valid:", str);
        return '?';
    }

    const options = {
        month: 'short',
        day: 'numeric'
    };

    if (timeZone) {
        options['timeZone'] = timeZone;
    }
    return new Intl.DateTimeFormat(navigator.language, options).format(parsed);
};

export const asTimeOnly = (str, timeZone) => {
    if (! str) { return '-'; }
    const parsed = Date.parse(str);
    if (isNaN(parsed)) {
        console.log("Date not recognised as valid:", str);
        return '?';
    }

    const options = {
        hour: 'numeric',
        minute: 'numeric'
    };

    if (timeZone) {
        options['timeZone'] = timeZone;
    }

    return new Intl.DateTimeFormat(navigator.language, options).format(parsed);
};

export const asDateTimeStamp = (str, timeZone) => {
    if (! str) { return '-'; }
    return asTimeOnly(str, timeZone)+' '+asDateStamp(str, timeZone);
};

export const asDayOfWeek = (str, timeZone) => {
    if (! str) { return '-'; }
    const parsed = Date.parse(str);
    if (isNaN(parsed)) {
        console.log("Date not recognised as valid:", str);
        return '?';
    }

    const options = {
        weekday: 'long'
    };

    if (timeZone) {
        options['timeZone'] = timeZone;
    }

    return new Intl.DateTimeFormat(navigator.language, options).format(parsed);
};

/** Given a duration in milliseconds, calculate the percentage between the two Date objects passed in.
 *
 * @param startTimeObj {Date} object
 * @param endTimeObj {Date} object
 * @param duration {Number} in milliseconds
 * @param minimum {Number} Minimum percentage to return
 * @returns {number|*}
 */
export const percentageWidthOfRange = (startTimeObj, endTimeObj, duration, minimum=0) => {
    const ms = endTimeObj - startTimeObj;
    //const mins = Math.floor(ms / (60*1000));
    const percentage = Math.floor((ms/duration) * 100);
    if (percentage < minimum) {
        return minimum;
    } else {
        return percentage;
    }
};
